import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { AttentionStrip } from './AttentionStrip'
import { BottomTabs } from './BottomTabs'
import { ShellProvider, useShell } from './shell'
import { Sidebar } from './Sidebar'

/** The console's frame: the sidebar from 768px up, bottom tabs below it, and
 *  the page in between. Pages that draw a PageHeader get the attention strip
 *  under it; the pages not yet moved get it at the top. */
export function AppShell() {
  return (
    <ShellProvider>
      <div className="min-h-screen bg-background text-foreground md:flex">
        <Sidebar className="hidden md:flex" />
        <div className="min-w-0 flex-1">
          <Main>
            <TopStrip />
            <Outlet />
          </Main>
        </div>
        <BottomTabs className="md:hidden" />
      </div>
    </ShellProvider>
  )
}

/** The page column: 1280px at most, unless the page asked for the full width. */
function Main({ children }: { children: ReactNode }) {
  const shell = useShell()
  return (
    <main
      className={cn(
        'mx-auto w-full px-4 pb-[calc(88px+env(safe-area-inset-bottom))] pt-4 md:px-6 md:pb-12 md:pt-6',
        shell && shell.wide > 0 ? 'max-w-none' : 'max-w-content',
      )}
    >
      {children}
    </main>
  )
}

function TopStrip() {
  const shell = useShell()
  if (shell && shell.headers > 0) return null
  return <AttentionStrip className="mb-4" />
}
